import { getDealsArticleConfig } from '../../../../utils/getDealsArticleConfig';
import type { TDealsContentConfig } from '../../../../types/dealsContentConfig';
import type { IDealsLeadFormBlockProps } from '../../../../components/DealsLeadForm';

/**
 * Собирает пропсы блока формы (подводка + DealsLeadForm), если фичетогл включён
 * и статья есть в RS dealsContentConfig.
 * Группа эксперимента здесь не учитывается — её проверяет DealsExperimentArticle.
 */
export const getDealsLeadFormProps = (
  postId: number,
  isDealsBannerExperimentEnabled: boolean | undefined,
  regionOptions: IDealsLeadFormBlockProps['regionOptions'],
  dealsContentConfig: TDealsContentConfig | null,
): IDealsLeadFormBlockProps | undefined => {
  if (!isDealsBannerExperimentEnabled) {
    return undefined;
  }

  const articleConfig = getDealsArticleConfig(postId, dealsContentConfig);

  if (!articleConfig) {
    return undefined;
  }

  return {
    leadIn: articleConfig.formLeadIn,
    title: articleConfig.formTitle,
    subtitle: articleConfig.formSubtitle,
    regionOptions,
  };
};
